import { apiSlice } from "./apiSlice";



const categorizeSubs = (responseData: any) => {
    const mapped: any = {
        GENERAL: [],
        AIAN: []
    };

    responseData.forEach((subApp: any) => {

        switch (subApp.ducType) {
        case "GENERAL":
            mapped.GENERAL.push(subApp);
            break;
        case "AIAN":
            mapped.AIAN.push(subApp);
            break;
        }
    });

    return mapped;
};


export const ducApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSignedDucUrlByUsername: builder.query({
            query: ({ username, ducType }) => `/duc/url/signed/${username}/ducType/${ducType}`,
            providesTags: () => [{ type: "DUCInfo" }],
        }),
        submitDUC: builder.mutation({
            query: data => ({
                url: '/duc',
                method: 'POST',
                body: { ...data },
                // LC-6448: the backend returns the DocuSign envelope ID as a bare text/plain body
                // (not JSON) on success. Without this, fetchBaseQuery's default JSON parser throws on
                // that body and treats even a successful 200 as a PARSING_ERROR, which fails
                // .unwrap() and makes the frontend show the raw envelope ID as an error and bounce
                // back to the dashboard instead of proceeding to "Sign my DUC".
                responseHandler: 'text'
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        getDUCInfo: builder.query({
            query: ({ email }) => `/duc/${email}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),

        getDUCUrl: builder.query({
            query: ({ id }) => `/duc/url/${id}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),

        getDUCFile: builder.query({
            query: ({ id }) => `/duc/file/${id}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),
        getTrainingUrl: builder.query({
            query: ({ username }) => `/training/${username}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),
        getDucInfoByID: builder.query({
            query: ({ id }) => `/duc/ducdetails/${id}`,
            providesTags: () => {
                return [{ type: "DUCInfo" }];
            },
        }),
        reSubmitDUC: builder.mutation({
            query: ({ data, id }) => ({
                url: `/duc/update/${id}`,
                method: 'PUT',
                body: { ...data },
                // LC-6448: see submitDUC above - this endpoint also returns a bare text/plain envelope ID.
                responseHandler: 'text'
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        checkSubApplicants: builder.mutation({
            query: (data) => ({
                url: `/duc/validate-subapplicants`,
                method: 'POST',
                body: { ...data }
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        deleteDUC: builder.mutation({
            query: ({ id }) => ({
                url: `/duc/cancel/${id}`,
                method: 'POST',
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        getSubApplicants: builder.query({
            query: ({ username }) => `/duc/${username}/subapplicants`,
            transformResponse: (responseData: any) => categorizeSubs(responseData),
            providesTags: ['DUCInfo'],
        }),

        revokeAccess: builder.mutation({
            query: ({ id }) => ({
                url: `/duc/subapplicants/revoke/${id}`,
                method: 'POST',
            }),
            invalidatesTags: ["DUCInfo"],
        }),

        addSubApplicant: builder.mutation({
            query: (data) => ({
                url: `/duc/add/subapplicants`,
                method: 'POST',
                body: { ...data },
                // LC-6448: see submitDUC above - this endpoint also returns a bare text/plain envelope ID.
                responseHandler: 'text'
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        getOwnershipTransferStatus: builder.query({
            query: ({ ducDetailsId }) => `/duc/${ducDetailsId}/transfer-ownership`,
            providesTags: () => [{ type: "DUCInfo" }],
        }),

        getOwnershipTransferPrefill: builder.query({
            query: ({ transferId }) => `/duc/transfer-ownership/${transferId}/prefill`,
            providesTags: () => [{ type: "DUCInfo" }],
        }),

        getIncomingOwnershipTransfer: builder.query({
            query: () => `/duc/transfer-ownership/incoming`,
            providesTags: () => [{ type: "DUCInfo" }],
        }),

        initiateOwnershipTransfer: builder.mutation({
            query: ({ ducDetailsId, ...data }) => ({
                url: `/duc/${ducDetailsId}/transfer-ownership`,
                method: 'POST',
                body: { ...data }
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

        cancelOwnershipTransfer: builder.mutation({
            query: ({ transferId, cancelReason }) => ({
                url: `/duc/transfer-ownership/${transferId}/cancel`,
                method: 'POST',
                body: { cancelReason }
            }),
            invalidatesTags: () => [{ type: "DUCInfo" }],
        }),

    })
});

export const {
    useSubmitDUCMutation,
    useGetDUCInfoQuery,
    useGetDUCUrlQuery,
    useGetDUCFileQuery,
    useGetTrainingUrlQuery,
    useGetDucInfoByIDQuery,
    useReSubmitDUCMutation,
    useCheckSubApplicantsMutation,
    useDeleteDUCMutation,
    useGetSubApplicantsQuery,
    useRevokeAccessMutation,
    useAddSubApplicantMutation,
    useGetSignedDucUrlByUsernameQuery,
    useLazyGetSignedDucUrlByUsernameQuery,
    useGetOwnershipTransferStatusQuery,
    useGetOwnershipTransferPrefillQuery,
    useGetIncomingOwnershipTransferQuery,
    useInitiateOwnershipTransferMutation,
    useCancelOwnershipTransferMutation
} = ducApiSlice;